import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShield } from "@fortawesome/pro-light-svg-icons";
import { Box, Grid } from "@mui/material";
import { BulletinContent, SideBar } from "../ArticleComponents";
import { PageHeader } from "../CommonComponents";

export function Bulletin() {

  const [searchQuery, setSearchQuery] = useState<string>("");
  const [selectedTag, setSelectedTag] = useState<string | null>(null);
  const [selectedTags, setSelectedTags] = useState<string[]>([]);

  // Function to handle the selection of tags in the sidebar
  const handleTagSelect = (tags: string[] | null) => {
    setSelectedTag(tags !== null ? tags[0] : null);
    setSelectedTags(tags || []);
  };

  return (
    <>
      <PageHeader
        setSearchQuery={setSearchQuery}
        searchQuery={searchQuery}
        text="Bulletin Articles"
        icon={
          <span className="fa-layers fa-fw">
            <FontAwesomeIcon icon={faShield} className="outer-icon" />
            <FontAwesomeIcon icon={faShield} transform="shrink-6" />
          </span>
        }
      />
      <Box sx={{ display: "flex" }}>
        <Grid container spacing={2}>
          <Grid item xs={8} sx={{ margin: "10px" }}>
            {/* Main Content */}
           
            <BulletinContent
              selectedTag={selectedTag}
              selectedTags={selectedTags}
              searchQuery={searchQuery}
            />
          </Grid>
          {/* SideBar */}
          <Grid item xs={3}>
            <Box
              sx={(theme) => { return {
                backgroundColor: theme.palette.background.default,
                height: "calc(100vh - 64px)",
                borderRadius: "none",
                top: 0,
              }
              }}
            >
              <SideBar onTagSelect={handleTagSelect} />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
